import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}`;
const model = abstractModel(resource);

export default model;
